import React from 'react';
import { Source, Layer, Marker } from 'react-map-gl';
import iconLight from '../../assets/svg/spot-marker-light.svg';
import iconDark from '../../assets/svg/spot-marker-dark.svg';
import { DEADBAND_CIRCLE_STYLE_OPTS, RADIUS_CIRCLE_STYLE_OPTS } from '../../config/map';
import { metersToPixelsAtMaxZoom } from '../utils/map';
import { useTheme } from '../contexts/theme';
import palette from '../../config/themes/palette';

const MapSpotLayer = ({ spot, activeSpotsIds }) => {
  const { theme } = useTheme();
  const center = [spot.position.lon, spot.position.lat];
  const isActive = activeSpotsIds?.includes(spot.id);

  const colors =
    theme === 'day'
      ? {
          active: palette.yellow,
          default: palette.brand,
        }
      : {
          active: palette.yellow,
          default: palette.white,
        };

  const feature = {
    type: 'Feature',
    id: `${spot.id}_feature`,
    geometry: {
      type: 'Point',
      coordinates: center,
    },
  };

  const radiusCircleSize = metersToPixelsAtMaxZoom(spot.position.radius, spot.position.lat);

  const deadbandCircleSize = metersToPixelsAtMaxZoom(
    spot.position.radius + spot.position.deadband,
    spot.position.lat
  );

  const radiusLayerStyle = {
    id: `${spot.id}_radius_circle`,
    type: 'circle',
    paint: {
      'circle-radius': {
        stops: [
          [0, 0],
          [20, radiusCircleSize],
        ],
        base: 2,
      },
      'circle-stroke-color': isActive ? colors.active : colors.default,
      'circle-color': isActive ? colors.active : colors.default,
      'circle-stroke-opacity': RADIUS_CIRCLE_STYLE_OPTS.opacity,
      'circle-stroke-width': RADIUS_CIRCLE_STYLE_OPTS.weight,
      'circle-stroke-color-transition': {
        duration: 1000,
        delay: 0,
      },
      'circle-opacity': RADIUS_CIRCLE_STYLE_OPTS.fillOpacity,
      'circle-color-transition': {
        duration: 1000,
        delay: 0,
      },
    },
  };

  const deadbandLayerStyle = {
    id: `${spot.id}_deadband_circle`,
    type: 'circle',
    paint: {
      'circle-radius': {
        stops: [
          [0, 0],
          [20, deadbandCircleSize],
        ],
        base: 2,
      },
      'circle-stroke-color': isActive ? colors.active : colors.default,
      'circle-color': isActive ? colors.active : colors.default,
      'circle-stroke-opacity': DEADBAND_CIRCLE_STYLE_OPTS.opacity,
      'circle-stroke-width': DEADBAND_CIRCLE_STYLE_OPTS.weight,
      'circle-stroke-color-transition': {
        duration: 1000,
        delay: 0,
      },
      'circle-opacity': DEADBAND_CIRCLE_STYLE_OPTS.fillOpacity,
      'circle-color-transition': {
        duration: 1000,
        delay: 0,
      },
    },
  };

  return (
    <>
      <Source id={`${spot.id}_source`} type="geojson" data={feature}>
        <Layer {...radiusLayerStyle} />
        <Layer {...deadbandLayerStyle} />
      </Source>

      <Marker longitude={spot.position.lon} latitude={spot.position.lat} anchor="center">
        <img alt="agami" src={theme === 'day' ? iconLight : iconDark} />
      </Marker>
    </>
  );
};

export default MapSpotLayer;
